import { LitElement, html, svg } from 'lit';

export class IconSend32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Papirfly</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1.866 4.99a2 2 0 0 1 2.631-2.769L29.85 15.1a1 1 0 0 1 0 1.783L4.497 29.779a2 2 0 0 1-2.63-2.77L8.61 15.991l-6.744-11ZM30.396 15.99H8.604"></path></svg>`; }
}
if (!customElements.get('f-icon-send32', IconSend32)) {
  customElements.define('f-icon-send32', IconSend32);
}